import type { JSX } from 'react';

import { Info } from '@mui/icons-material';
import type { TooltipProps } from '@mui/material';
import { IconButton, Tooltip } from '@mui/material';


interface InfoTooltipProps {
  text: string;
  placement?: TooltipProps['placement'];
}


const InfoTooltip = ({
  text,
  placement = 'top'
}: InfoTooltipProps): JSX.Element => (
  <Tooltip title={text} placement={placement} arrow>
    <IconButton
      size="small"
      sx={{
        padding: 0,
        verticalAlign: 'middle'
      }}
    >
      <Info sx={{ color: '#404945', fontSize: 24 }} />
    </IconButton>
  </Tooltip>
);

export default InfoTooltip;